<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import Lenis from '@studio-freight/lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Header from '../components/HeaderView.vue'
import HeroSection from '../components/HeroSection.vue'
import Footer from '../components/FooterView.vue'
import CompanyLogos from '../components/CompanyLogos.vue'
import HomeSection2 from '../components/HomeSection2.vue'
import UseCasesSection from '../components/UseCasesSection.vue'
import DiscoverFtrack from '../components/DiscoverFtrack.vue'
import DemoSection from '../components/DemoSection.vue'

// Registrar ScrollTrigger
gsap.registerPlugin(ScrollTrigger)

let lenis: Lenis | null = null

onMounted(() => {
  // Inicializar Lenis
  lenis = new Lenis({
    lerp: 0.1, // Ajusta la velocidad de la transición (más bajo es más lento)
    smoothWheel: true, // Activa el scroll suave
  })

  // --- INTEGRACIÓN LENIS + SCROLLTRIGGER ---
  // Lenis aplica un scroll virtual, por lo que ScrollTrigger necesita saber cómo actualizarse
  lenis.on('scroll', ScrollTrigger.update)

  // Sincronizar el ticker de GSAP con Lenis
  gsap.ticker.add((time) => {
    lenis?.raf(time * 1000)
  })

  // Desactivar el lag smoothing de GSAP para mejor sincronización con Lenis
  gsap.ticker.lagSmoothing(0)

  // Iniciar el scroll animado
  function raf(time: number) {
    lenis?.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  // Restablecer scroll al inicio de la página
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

onBeforeUnmount(() => {
  if (lenis) {
    lenis.destroy()
  }
})
</script>

<template>
  <main>
    <Header />
    <HeroSection />
    <CompanyLogos />
    <HomeSection2 />
    <DiscoverFtrack />
    <DemoSection />
    <UseCasesSection />
    <Footer />
  </main>
</template>

<style></style>
